import React, { useState } from "react";
import styles from "../../styles/StartupPotential/StartupPotential.module.css";
import InsightComponent from "./InsightComponent";
import FreeEvaluationForm from "../../UsefulCompoments/FreeEvaluationForm";

const insights = [
  {
    src: "/business1.svg",
    desc: ["Clear Insights Into Your Business", "Strengths And Gaps"],
  },
  {
    src: "/consultant1.svg",
    desc: ["Expert Advice Tailored To Your", "Growth Stage"],
  },
  {
    src: "bar-chart1.svg",
    desc: ["A Step-By-Step Action Plan To", "Scale Smarter"],
  },
];

const StartupPotential = ({handleSetSucess,handleFreeEvaluationClick,showForm, setShowForm}) => {
  return (
    <React.Fragment>
      <div id={styles.PotentialContainer}>
        <div id={styles.PotentialInnerContainer}>
          <div id={styles.PotentialTitle}>Unlock Your Startup’s Potential</div>
          <div id={styles.PotentialDesc}>
            Are you ready to take your startup to the next level? Don’t let
            unanswered questions hold you back. With our Free Startup
            Evaluation, you’ll get
          </div>

          <div id={styles.InsightContainer}>
            {insights.map((insight, index) => (
              <InsightComponent key={index} insight={insight} />
            ))}
          </div>

          <div id={styles.InsightMobile}>
            <p id={styles.InsightInfo}>
              This is your chance to get real value at no cost and make
              decisions with confidence 🚀 Why wait?
            </p>
          </div>
          <div>
            <button
              className={styles.InsightBtn}
              onClick={handleFreeEvaluationClick}
            >
              Claim Free Evaluation Now
            </button>
          </div>
          <div id={styles.InsightWeb}>
            <p id={styles.InsightInfo}>
              This is your chance to get real value at no cost and make
              decisions with confidence 🚀 Why wait?
            </p>
          </div>
        </div>
      </div>
      {showForm && <FreeEvaluationForm setShowForm={setShowForm} handleSetSucess={handleSetSucess} />}
    </React.Fragment>
  );
};

export default StartupPotential;
